module.exports = __webpack_public_path__ + "static/media/amm1.ca549fe1.jpg";